import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { SpraEmiRow, SpraRentalEmiDetail, SpraRentalEmiModel } from 'src/app/Models/ops';
import { Utility } from 'src/app/Utilities/utility';

@Component({
  selector: 'app-spra-rental-emi',
  templateUrl: './spra-rental-emi.component.html',
  styleUrls: ['./spra-rental-emi.component.css']
})
export class SpraRentalEmiComponent implements OnInit {
  public  utility: Utility;
  public spraRentalEmiModel:SpraRentalEmiModel  
  constructor(
    private cookieService:CookieService,
    private dialogRef: MatDialogRef<SpraRentalEmiComponent>,    
    @Inject(MAT_DIALOG_DATA) public data:any
    ) {
      this.spraRentalEmiModel = new SpraRentalEmiModel();
      this.utility =  new Utility(this.cookieService);
     }

  ngOnInit(): void {


    // this.spraRentalEmiModel.EmiDetailWithOutFreeCopy.TotalRentalAmount = 75000;
    // this.spraRentalEmiModel.EmiDetailWithOutFreeCopy.LoanAmount = 41234;
    // this.spraRentalEmiModel.EmiDetailWithOutFreeCopy.RateOfInterest = 9;
    // this.spraRentalEmiModel.EmiDetailWithOutFreeCopy.LockInMonths = 30;
    // this.spraRentalEmiModel.EmiDetailWithOutFreeCopy.EMI = 1540;
    // this.spraRentalEmiModel.EmiDetailWithFreeCopy.TotalRentalAmount = 75000;
    // this.spraRentalEmiModel.EmiDetailWithFreeCopy.LoanAmount = 66938;
    // this.spraRentalEmiModel.EmiDetailWithFreeCopy.RateOfInterest = 9;
    // this.spraRentalEmiModel.EmiDetailWithFreeCopy.LockInMonths = 30;
    // this.spraRentalEmiModel.EmiDetailWithFreeCopy.FreeCopyValue = 960;
    // this.spraRentalEmiModel.EmiDetailWithFreeCopy.EMI = 2500;

    this.BindEmiDetail();

  }


  BindEmiDetail(){

    if(this.data != undefined){
      this.spraRentalEmiModel = this.data.spraRentalEmiModel;
    }
    this.utility.CreateEmiChart(this.spraRentalEmiModel.EmiDetailWithFreeCopy);
    this.utility.CreateEmiChart(this.spraRentalEmiModel.EmiDetailWithOutFreeCopy);
  }


  


  Close() { 
      this.dialogRef.close({ event: 'Close', data: {} });    
  }

}
